import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(Router)
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   当设置 true 的时候该路由不会在侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1(默认 false)
 *
 * alwaysShow: true               当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 *
 * redirect: noRedirect           当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 *                                如果设置路径（/index）重定向地址，在面包屑中点击会重定向去的地址
 *
 * name:'router-name'             设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    roles: ['admin','editor']     设置该路由进入的权限，支持多个权限叠加
    title: 'title'                设置该路由在侧边栏和面包屑中展示的名字(recommend set)
    icon: 'svg-name'/'el-icon-x'  设置该路由的图标，支持 svg-class，也支持 el-icon-x element-ui 的 icon
    noCache: true                 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    affix: true                   如果设置为true，它则会固定在tags-view中(默认 false)
    breadcrumb: false             如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
    activeMenu: '/example/list'   当路由设置了该属性，则会高亮相对应的侧边栏
                                  这在某些场景非常有用，比如：一个文章的列表页路由为：/article/list
                                  点击文章进入文章详情页，这时候路由为/article/1，但你想在侧边栏高亮文章列表的路由，就可以进行如下设置
  }
 */
export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: 'Dashboard',
  //       meta: { title: 'dashboard', icon: 'dashboard', noCache: true, affix: true }
  //     }
  //   ]
  // },
  {
     
    path: '/',
    component: () => import('@/views/dashboard/index'),
    name: 'Dashboard',
    meta: { title: 'dashboard', icon: 'dashboard', noCache: true, affix: true }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
 
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/guide',   //系统管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'guide',
    alwaysShow: true, 
    meta: {
      title: 'guide',
      icon: 'list',
    },
    children: [
      {
        path: 'user',
        component: () => import('@/views/guide/user'),
        name: 'user',
        meta: { title: 'guide1', icon: 'user', roles:['admin']}
      },
      {
        path: 'role1',
        component: () => import('@/views/guide/role1'),
        name: 'role1',
        meta: { title: 'guide2', icon: 'peoples', roles:['admin'] }
      },
      {
        path: 'regional',
        component: () => import('@/views/guide/regional'),
        name: 'regional',
        meta: { title: 'guide3', icon: 'international', roles:['admin'] }
      },
      {
        hidden: true,
        path: 'personal',
        component: () => import('@/views/guide/personal'),
        name: 'personal',
        meta: { title: 'personal', icon: 'form', breadcrumb: false , }
      }
    ]
  },
  { 
    path: '/service',     //服务管理
    component: Layout, 
    redirect: 'noRedirect',
    name: 'service',
    alwaysShow: true, 
    meta: {
      title: 'service',
      icon: 'tree',
    },
    children: [
      {
        path: 'personnel',
        component: () => import('@/views/service/personnel'),
        name: 'personnel',
        meta: { title: 'service1', icon: 'theme', roles:['admin']}
      },{
        path: 'volunteer',
        component: () => import('@/views/service/volunteer'),
        name: 'volunteers',
        meta: { title: 'volunteers', icon: 'volunte', roles:['admin']}
      },
      {
        path: 'customer',
        component: () => import('@/views/service/customer'),
        name: 'customer',
        meta: { title: 'service2', icon: 'peoples', roles:['admin'] }
      },{
        path: 'customerLog',
        component: () => import('@/views/service/customerLog'),
        name: 'customerLog',
        meta: { title: 'customerLog', icon: 'list', roles:['admin'] }
      },{
        hidden: true,
        path: 'details1',
        component: () => import('@/views/service/details1'),
        name: 'details1',
        meta: { title: 'service5', icon: 'form', breadcrumb: false, activeMenu: '/service/customer'}
      },{
        hidden: true,
        path: 'detailLog',
        component: () => import('@/views/service/detailLog'),
        name: 'details1',
        meta: { title: 'service5', icon: 'form', breadcrumb: false, activeMenu: '/service/customerLog'}
      },
      {
        path: 'record',
        component: () => import('@/views/service/record'),
        name: 'record',
        meta: { title: 'service3', icon: 'form', roles:['admin'] }
      },
	  {
	    hidden: true,
	    path: 'details',
	    component: () => import('@/views/service/details'),
	    name: 'details',
	    meta: { title: 'service5', icon: 'form', activeMenu: '/service/record'}
	  },
      {
        path: 'category',
        component: () => import('@/views/service/category'),
        name: 'category',
        meta: { title: 'service4', icon: 'component', roles:['admin'] }
      },
	  {
		hidden: true,
	    path: 'category/project',
	    component: () => import('@/views/service/project'),
	    name: 'project',
	    meta: { title: 'service45', icon: 'form', roles:['admin'],activeMenu:'/service/category'}
	  },
      // {
      //   path: 'callRecords',
      //   component: () => import('@/views/guide/callRecords'),
      //   name: 'callRecords',
      //   meta: { title: 'callRecords', icon: 'email', breadcrumb: false, roles:['admin'] }
      // },
    ]
  },
  {
    path: '/recycle',//回收站
    component: Layout,
    redirect: 'noRedirect',
    name: 'recycle',
    alwaysShow: true, 
    meta: {
      title: 'recycle',
      icon: 'recycle',
    },
    children: [
      {
        path: 'restore',
        component: () => import('@/views/recycle/index'),
        name: 'recycle1',
        meta: { title: 'recycle', icon: 'recycleList', roles:['admin']}
      }
    ]
  },
  {
    path: '/operate',// 运营管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'operate',
    alwaysShow: true, 
    meta: {
      title: 'operate',
      icon: 'operate',
    },
    children: [
      {
        path: '/news',
        component: () => import('@/views/operate/news/index'),
        name: 'news',
        meta: { title: 'news', icon: 'zix', roles:['admin']}
      },
      {
        path: '/notice',
        component: () => import('@/views/operate/notice/index'),
        name: 'notice',
        meta: { title: 'notice', icon: 'noy', roles:['admin']}
      },
      {
        path: '/activity',
        component: () => import('@/views/operate/activity/index'),
        name: 'activity',
        meta: { title: 'activity', icon: 'act', roles:['admin']}
      },
      {
        path: '/activityAdd',
        component: () => import('@/views/operate/activity/add'),
        name: 'activityAdd',
        hidden: true,
        meta: { title: 'activityAdd', icon: 'documentation'}
      },
      {
        hidden: true,
        path: '/enrollList',
        component: () => import('@/views/operate/activity/enrollList'),
        name: 'enrollList',
        meta: { title: 'enrollList', icon: 'documentation',activeMenu: '/operate/activity'}
      },
      
      {
        path: '/recruit',
        component: () => import('@/views/operate/recruit/index'),
        name: 'recruit',
        meta: { title: 'recruit', icon: 'pin', roles:['admin']}
      },
      {
        path: '/recruitAdd',
        component: () => import('@/views/operate/recruit/add'),
        name: 'recruitAdd',
        hidden: true,
        meta: { title: 'recruitAdd', icon: 'documentation'}
      },
      {
        hidden: true,
        path: '/applicants',
        component: () => import('@/views/operate/recruit/applicants'),
        name: 'applicants',
        meta: { title: 'applicants', icon: 'documentation',activeMenu: '/operate/recruit'}
      }
    ]
  },{
    path: '/company',// 企业管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'company',
    alwaysShow: true, 
    meta: {
      title: 'company',
      icon: 'company',
    },
    children: [
      {
        path: '/auth',
        component: () => import('@/views/company/auth/index'),
        name: 'auth',
        meta: { title: 'auth', icon: 'auth', roles:['admin']}
      }
    ]
  },
  {
    path: '/message',// 消息管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'message',
    alwaysShow: false, 
    hidden: true,
    meta: {
      title: 'message',
      icon: '',
    },
    children: [
      {
        path: '/msgList',
        component: () => import('@/views/message/index'),
        name: 'message',
        meta: { title: 'message', icon: ''}
      }
    ]
  },
  
  { path: '*', redirect: '/404', hidden: true }
]